(() => {
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const target = Date.parse(root.dataset.target);
    if (!Number.isFinite(target)) return;
    const fields = ['days', 'hours', 'minutes', 'seconds'].map(key => root.querySelector(`[data-${key}]`));
    const expired = root.querySelector('[data-expired]');
    let interval = null;
    function update() {
      if (!root.isConnected) { destroy(); return; }
      const remaining = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      fields.forEach((field, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (field && field.textContent !== value) field.textContent = value;
      });
      if (expired) expired.hidden = remaining > 0;
      if (remaining === 0 && interval !== null) { clearInterval(interval); interval = null; }
    }
    function destroy() {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('pageshow', update);
      instances.delete(root);
    }
    instances.set(root, destroy);
    interval = setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
    update();
  }
  function mountAll(scope) {
    if (scope.matches?.('[data-countdown]')) mount(scope);
    scope.querySelectorAll('[data-countdown]').forEach(mount);
  }
  mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-countdown]').forEach(root => instances.get(root)?.());
  });
})();
